import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExchangeResponse, Tenant } from '../../../models/domain';
import { AbstractAuthConfigService } from '../../abstract-auth-config/abstract-auth-config.service';
import { AbstractService } from '../abstract-http/abstract-service';

@Injectable()
export class TenantService extends AbstractService {
  constructor(httpClient: HttpClient, configService: AbstractAuthConfigService) {
    super(httpClient, configService);
  }

  getTenantBySubdomain(tenant_subdomain: string): Observable<Tenant> {
    return this.http.get<Tenant>(
      this.buildUrl(({ getTenant }) => getTenant),
      {
        params: {
          tenant_subdomain,
        },
        headers: {
          'No-Auth': 'true',
        },
      },
    );
  }

  exchangeToken(codeId: string, codeSecret: string): Observable<ExchangeResponse> {
    return this.http.post<ExchangeResponse>(
      this.buildUrl(({ exchange }) => exchange),
      { code_id: codeId, code_secret: codeSecret },
      {
        headers: new HttpHeaders({
          'No-Auth': 'true',
        }),
      },
    );
  }

  createAuditorSimulationToken(frameworkId: string): Observable<string> {
    return this.http.post<string>(
      `${this.getBaseUrl()}/authentication/create-auditor-simulation-token`,
      {
        audit_frameworks: [frameworkId],
      },
      { responseType: 'text' as 'json' },
    );
  }

  private getBaseUrl(): string {
    return window['__AnPlatformConfiguration__'].identityApi.baseUrl;
  }
}
